import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const phoneNumberFieldDefaultVariants = {
  "error": false,
  "disabled": false,
  "labelHidden": false
}
const phoneNumberFieldCompoundVariants = []

const phoneNumberFieldSlotNames = [
  [
    "container",
    "PhoneNumberField__container"
  ],
  [
    "label",
    "PhoneNumberField__label"
  ],
  [
    "fieldWrapper",
    "PhoneNumberField__fieldWrapper"
  ],
  [
    "countryButton",
    "PhoneNumberField__countryButton"
  ],
  [
    "dialCode",
    "PhoneNumberField__dialCode"
  ],
  [
    "input",
    "PhoneNumberField__input"
  ],
  [
    "error",
    "PhoneNumberField__error"
  ]
]
const phoneNumberFieldSlotFns = /* @__PURE__ */ phoneNumberFieldSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, phoneNumberFieldDefaultVariants, getSlotCompoundVariant(phoneNumberFieldCompoundVariants, slotName))])

const phoneNumberFieldFn = memo((props = {}) => {
  return Object.fromEntries(phoneNumberFieldSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const phoneNumberFieldVariantKeys = [
  "labelHidden",
  "error",
  "disabled"
]
const getVariantProps = (variants) => ({ ...phoneNumberFieldDefaultVariants, ...compact(variants) })

export const phoneNumberField = /* @__PURE__ */ Object.assign(phoneNumberFieldFn, {
  __recipe__: false,
  __name__: 'phoneNumberField',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: phoneNumberFieldVariantKeys,
  variantMap: {
  "labelHidden": [
    "true"
  ],
  "error": [
    "true"
  ],
  "disabled": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, phoneNumberFieldVariantKeys)
  },
  getVariantProps
})